import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { NON_EN_CODES } from "../i18n";
import { Shield } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { i18n } = useTranslation();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-4">
          <Shield className="h-10 w-10 text-teal-600 animate-pulse" />
          <p className="text-sm text-muted-foreground font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const intended = location.pathname + location.search;
    const lang = i18n.language;
    const prefix = NON_EN_CODES.includes(lang) ? `/${lang}` : "";
    return <Navigate to={`${prefix}/auth?redirect=${encodeURIComponent(intended)}`} replace />;
  }

  return children;
}
